import React, { useState, useEffect, useMemo } from 'react';

interface CountdownTimerProps {
  expirationDate: string; // ISO date string
  className?: string;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ expirationDate, className = "text-2xl font-bold text-red-600" }) => {
  const targetDate = useMemo(() => new Date(expirationDate).getTime(), [expirationDate]);
  const [timeLeft, setTimeLeft] = useState(targetDate - new Date().getTime());

  useEffect(() => {
    if (targetDate < new Date().getTime()) {
      setTimeLeft(0);
      return;
    }

    const intervalId = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;
      setTimeLeft(distance);

      if (distance < 0) {
        clearInterval(intervalId);
        setTimeLeft(0);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [targetDate]);

  const formatTime = (ms: number) => {
    if (ms <= 0) {
      return 'Tempo esgotado';
    }
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    if (hours > 0) {
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  return (
    <div className={className} role="timer" aria-live="assertive">
      {formatTime(timeLeft)}
    </div>
  );
};

export default CountdownTimer; 